import dispatcher from "../Dispatcher";
import actionTypes from "./ActionTypes";
import axios from "axios";
import * as Globals from "../Globals";
import { Logout } from "./LoginActions";
export function CreateIntakeStrategy(strategyName) {
  axios.post(
    `${Globals.baseUrl}/IntakeStrategy/Create`,
    { name: strategyName },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.IntakeStrategyCreate,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function LoadIntakeStrategies() {
  axios.get(`${Globals.baseUrl}/IntakeStrategy/LoadStrategies`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.IntakeStrategyLoad,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function LoadIntakeStrategy(id) {
  axios.post(
    `${Globals.baseUrl}/IntakeStrategy/Lookup`,
    { isId: id },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.IntakeStrategyLoadOne,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((res) => {
    console.log("IS error");
  });
}
export function LoadStrategyById(id) {
  axios.post(
    `${Globals.baseUrl}/IntakeStrategyP/LookupByObjId`,
    { bpObjId: id },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.IntakeStrategyLoadOne,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((res) => {
    console.log("IS error");
  });
}
export function UpdateIntakeStrategy(update) {
  console.log(update);
  axios.post(
    `${Globals.baseUrl}/IntakeStrategy/Update`,
    { strategy: update },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.IntakeStrategyUpdate,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((res) => {
    console.log("IS error");
  });
}
export function DeleteIntakeStrategy(update) {
  axios.post(
    `${Globals.baseUrl}/IntakeStrategy/Delete`,
    { strategy: update },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.IntakeStrategyDelete,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((res) => {
    console.log("IS error");
  });
}
